import api from "./api";
import endpoints from "./endpoints";

export default {
  getAllExternalDataConnectionNames: async function () {
    const response = await api.get(endpoints.externalData.getAllExternalDataConnectionNames, { params: {} });
    return response.data;
  },
  getAllSelectionCommandsGrouped: async function () {
    const response = await api.get(endpoints.externalData.getAllSelectionCommandsGrouped);
    return response.data;
  },
  getSourceColumnNameOfSelectionCommand: async function (selectedCommandId: string) {
    const response = await api.get(endpoints.externalData.getSingleColumnNameOfSelectionCommand, {
      params: { selectedCommandId: selectedCommandId }
    });
    return response.data;
  }
};
